<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">販促画像パターン基本情報設定</h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              ブランド名
            </label>
            <div class="md-layout-item md-size-40  md-xsmall-size-100">
              <brand-select v-model="brandId" :noSelectFlag="true" :touchedFlag="true"></brand-select>
            </div>
          </div>
          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              販促画像パターン名
            </label>
            <div class="md-layout-item">
              <md-field :class="[
                {'md-error': errors.has('promotionImagePatternName')},
                {'md-valid': !errors.has('promotionImagePatternName') && touched.promotionImagePatternName}]">
                <md-input
                  v-model="promotionImagePatternName"
                  data-vv-name="promotionImagePatternName"
                  type="text"
                  v-validate= "modelValidations.promotionImagePatternName"
                  required>
                </md-input>
                <slide-y-up-transition>
                  <div class="vErrorText" v-show="errors.has('promotionImagePatternName')">【必須】255文字以内で入力してください</div>
                </slide-y-up-transition>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('promotionImagePatternName')">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('promotionImagePatternName') && touched.promotionImagePatternName">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
          </div>
          <div class="md-layout md-layout-item md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              ステータス
            </label>
            <div class="md-layout-item md-size-20 md-xsmall-size-100">
              <md-field :class="[
                {'md-error': errors.has('status')},
                {'md-valid': !errors.has('status') && touched.status}]">
                <md-select
                  v-model="status"
                  data-vv-name="status"
                  v-validate= "modelValidations.status"
                  required>
                  <md-option value="active">有効</md-option>
                  <md-option value="not_active">無効</md-option>
                </md-select>
                <slide-y-up-transition>
                  <div class="vErrorText" v-show="errors.has('status')">【必須】必ず一つ選択してください</div>
                </slide-y-up-transition>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('status')" style="margin-right:20px">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="!errors.has('status') && touched.status" style="margin-right:20px">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </div>
          </div>

        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>settings</md-icon>
          </div>
          <h4 class="title">販促画像設定</h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout md-size-100">
            <label class="md-layout-item md-size-15 md-form-label md-xsmall-size-100">
              イメージ画像
            </label>
            <div class="md-layout-item md-size-85 md-xsmall-size-100">
              <div v-for="(image, index) in images" :key="image.id || index" v-if="!image._destroy" class="image-form-item md-size-100">
                <md-button class="md-just-icon md-simple delete-form-button" @click="removeImageForm(index)">
                  <md-icon>close</md-icon>
                </md-button>
                <div class="order-controls">
                  <md-button class="md-just-icon md-simple" @click="moveUp(index)" :disabled="!canMoveUp(index)">
                    <md-icon>arrow_upward</md-icon>
                  </md-button>
                  <span class="order-number">{{ getDisplayOrder(index) }}</span>
                  <md-button class="md-just-icon md-simple" @click="moveDown(index)" :disabled="!canMoveDown(index)">
                    <md-icon>arrow_downward</md-icon>
                  </md-button>
                </div>
                <div class="md-layout md-size-100">
                  <div class="md-layout-item md-size-40 md-xsmall-size-100">
                  <div class="file-input">
                    <div v-if="!image.imageInfo">
                      <div class="image-container">
                        <img :src="dummyImg" title="">
                      </div>
                    </div>
                    <div class="image-container" v-else>
                      <img :src="image.imageInfo" />
                    </div>
                    <div class="button-container">
                      <md-button class="md-danger md-round" @click="removeImage(index)" v-if="image.imageInfo"><i class="fa fa-times"></i>削除</md-button>
                      <md-button class="md-success md-round md-fileinput">
                        <template v-if="!image.imageInfo">画像選択</template>
                        <template v-else>変更</template>
                        <input type="file" @change="onFileChange($event, index)" accept="image/*">
                      </md-button>
                    </div>
                  </div>
                </div>
                <div class="md-layout-item md-size-60 md-xsmall-size-100">
                  <div class="md-layout md-size-100" style="margin-bottom: 10px;">
                    <label class="md-layout-item md-size-20 md-form-label md-xsmall-size-100">
                      表示開始
                    </label>
                    <div class="md-layout-item md-size-30 md-xsmall-size-100" style="position:relative">
                      <vuejs-datepicker
                        :format="DatePickerFormat"
                        v-model="image.startDate"
                        :language="ja"
                      ></vuejs-datepicker>
                      <md-button
                        class="md-just-icon md-default md-simple dateDelete"
                        @click.native="image.startDate = ''; image.startTime = '00:00'"
                        v-if="image.startDate">
                        <md-icon>close</md-icon>
                      </md-button>
                    </div>
                    <time-select v-model="image.startTime" :disabled="false"></time-select>
                  </div>
                  <div class="md-layout md-size-100">
                    <label class="md-layout-item md-size-20 md-form-label md-xsmall-size-100">
                      表示終了
                    </label>
                    <div class="md-layout-item md-size-30 md-xsmall-size-100" style="position:relative">
                      <vuejs-datepicker
                        :format="DatePickerFormat"
                        v-model="image.endDate"
                        :language="ja"
                      ></vuejs-datepicker>
                      <md-button
                        class="md-just-icon md-default md-simple dateDelete"
                        @click.native="image.endDate = ''; image.endTime = '00:00'"
                        v-if="image.endDate">
                        <md-icon>close</md-icon>
                      </md-button>
                    </div>
                    <time-select v-model="image.endTime" :disabled="false"></time-select>
                  </div>
                </div>
                </div>
              </div>
              <div class="md-layout md-size-100" style="margin-top: 20px;">
                <md-button class="md-primary md-round" @click="addImageForm">
                  <i class="fa fa-plus"></i> 画像を追加
                </md-button>
              </div>
            </div>
          </div>

        </md-card-content>
        <md-card-actions md-alignment="left" class="mt60 mx-auto">
          <md-button class="md-warning md-lg" @click.native.prevent="returnBack">戻る</md-button>
          <submit-button class="md-success md-lg mL40" :onclick="validate" :buttonWord=this.buttonWord type="submit"></submit-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
  import SubmitButton from '../components/additional/SubmitButton.vue'
  import BrandSelect from '../components/additional/BrandSelect.vue'
  import TimeSelect from '../components/additional/TimeSelect.vue'
  import router from '../packs/router.js'
  import EventBus from '../mixins/event-bus.js';

  export default {
    components: {
      BrandSelect,
      SubmitButton,
      TimeSelect,
    },
    computed: {
    },
    props: {
      dummyImg: {
        type: String,
        default: '/images/image_placeholder.jpg'
      }
    },
    data () {
      return {
        id: '',
        buttonWord: '登録',
        brandId: '',
        promotionImagePatternName: '',
        status: '',
        images: [
          { id: null, imageInfo: '', file: null, startDate: '', startTime: '00:00', endDate: '', endTime: '00:00', _destroy: false }
        ],
        newFlag: false,
        touched: {
          promotionImagePatternName: false,
          status: false,
        },
        modelValidations: {
          promotionImagePatternName: {
            required: true,
            max: 255
          },
          status: {
            required: true
          },
        },
        modalFlag: false,
        icons: []
      }
    },
    methods: {
      combineDateTimeToDate(date, time) {
        if (!date) return null;
        const d = new Date(date);
        const [hours, minutes] = (time || '00:00').split(':');
        d.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
        return d;
      },
      formatDateTime(date, time) {
        if (!date) return '';
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const [hours, minutes] = (time || '00:00').split(':');
        return `${year}-${month}-${day} ${hours}:${minutes}:00`;
      },
      returnBack () {
        router.push({ path: '/admin/checkin_promotion_list/' })
      },
      getPromotionImagePattern () {
        this.axios({
          method  : 'GET',
          url     : this.AdminApiUrl + '/checkin_promotions/' + this.$route.params.id,
          timeout : 30000,
          headers : {'Authorization': this.$Cookies.get('accessToken')}
        }).then(response => {
          response.data.brand_id === null ? this.brandId='選択しない' :  this.brandId = response.data.brand_id
          this.promotionImagePatternName = response.data.name
          this.status = response.data.status
          
          if (response.data.images && response.data.images.length > 0) {
            this.images = response.data.images.map((img) => {
              const parseDateTime = (dateTimeStr) => {
                if (!dateTimeStr) return { date: '', time: '' };
                const dt = new Date(dateTimeStr);
                return {
                  date: dt,
                  time: `${String(dt.getHours()).padStart(2, '0')}:${String(dt.getMinutes()).padStart(2, '0')}`
                };
              };

              const start = parseDateTime(img.start_date);
              const end = parseDateTime(img.end_date);

              return {
                id: img.id,
                imageInfo: img.image_url || '',
                file: null,
                startDate: start.date,
                startTime: start.time,
                endDate: end.date,
                endTime: end.time,
                _destroy: false
              };
            });
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.tokenError()
          } else {
            this.dangerNotify('販促画像パターン情報を正しく取得できませんでした')
          }
        })
      },
      addImageForm() {
        this.images.push({
          id: null,
          imageInfo: '',
          file: null,
          startDate: '',
          startTime: '00:00',
          endDate: '',
          endTime: '00:00',
          _destroy: false
        });
      },
      onFileChange(e, index) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;

        const file = files[0];
        const maxSizeInMB = 2;
        const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

        const allowedExtensions = ['jpg', 'jpeg', 'png'];
        const fileName = file.name.toLowerCase();
        const extension = fileName.split('.').pop();

        if (!allowedExtensions.includes(extension)) {
          this.dangerNotify(`販促画像の形式が不正です。jpg、jpeg、png形式の画像を選択してください。`);
          e.target.value = '';
          return;
        }

        const allowedMimeTypes = ['image/jpeg', 'image/png'];
        if (!allowedMimeTypes.includes(file.type)) {
          this.dangerNotify('販促画像の形式が不正です。jpg、jpeg、png形式の画像を選択してください。');
          e.target.value = '';
          return;
        }

        if (file.size > maxSizeInBytes) {
          this.dangerNotify(`画像ファイルサイズが大きすぎます。${maxSizeInMB}MB以下の画像を選択してください。`);
          e.target.value = '';
          return;
        }

        this.createImage(file, index);
      },
      createImage(file, index) {
        let reader = new FileReader();
        let $this = this;

        reader.onload = (e) => {
          $this.images[index].imageInfo = e.target.result;
          $this.images[index].file = file;
        };
        reader.readAsDataURL(file);
      },
      removeImage(index) {
        this.images[index].imageInfo = '';
        this.images[index].file = null;
      },
      getDisplayOrder(index) {
        let order = 1;
        for (let i = 0; i < index; i++) {
          if (!this.images[i]._destroy) {
            order++;
          }
        }
        return order;
      },
      canMoveUp(index) {
        for (let i = index - 1; i >= 0; i--) {
          if (!this.images[i]._destroy) {
            return true;
          }
        }
        return false;
      },
      canMoveDown(index) {
        for (let i = index + 1; i < this.images.length; i++) {
          if (!this.images[i]._destroy) {
            return true;
          }
        }
        return false;
      },
      moveUp(index) {
        for (let i = index - 1; i >= 0; i--) {
          if (!this.images[i]._destroy) {
            const temp = this.images[index];
            this.$set(this.images, index, this.images[i]);
            this.$set(this.images, i, temp);
            break;
          }
        }
      },
      moveDown(index) {
        for (let i = index + 1; i < this.images.length; i++) {
          if (!this.images[i]._destroy) {
            const temp = this.images[index];
            this.$set(this.images, index, this.images[i]);
            this.$set(this.images, i, temp);
            break;
          }
        }
      },
      removeImageForm(index) {
        this.$set(this.images[index], '_destroy', true);
      },
      validate() {
        return new Promise((resolve) => {
          setTimeout(() => {
            const activeImages = this.images.filter(img => !img._destroy);

            if (activeImages.length === 0) {
              this.dangerNotify('画像を少なくとも1つ追加してください。');
              resolve();
              return;
            }

            for (let i = 0; i < activeImages.length; i++) {
              const image = activeImages[i];
              if (!image.imageInfo || image.imageInfo === '') {
                this.dangerNotify(`画像${i + 1}が設定されていません。画像を選択してください。`);
                resolve();
                return;
              }
            }

            for (let i = 0; i < activeImages.length; i++) {
              const image = activeImages[i];

              if (image.startDate && image.endDate) {
                const startDateTime = this.combineDateTimeToDate(image.startDate, image.startTime || '00:00');
                const endDateTime = this.combineDateTimeToDate(image.endDate, image.endTime || '00:00');

                if (endDateTime <= startDateTime) {
                  this.dangerNotify(`画像${i + 1}の表示期間：終了日時は開始日時より後に設定してください`);
                  resolve();
                  return;
                }
              }
            }

            EventBus.$emit('validate', this.errors)
            this.$validator.validateAll().then(isValid => {
              if (this.errors.items.length == 0) {
                this.updatePromotionImagePattern()
              } else {
                this.validateError()
              }
            })
            resolve();
          }, this.ResolveTime);
        });
      },
      updatePromotionImagePattern(){
        const formData = new FormData();

        formData.append('checkin_promotion[brand_id]', this.brandId === '選択しない' ? '' : this.brandId);
        formData.append('checkin_promotion[name]', this.promotionImagePatternName);
        formData.append('checkin_promotion[status]', this.status);

        let imageIndex = 0;
        let position = 1;

        this.images.forEach((image) => {
          if (!image.id && !image.file && !image.imageInfo) {
            return;
          }

          const prefix = `checkin_promotion[checkin_promotion_images_attributes][${imageIndex}]`;

          if (image.id) {
            formData.append(`${prefix}[id]`, image.id);
          }

          if (image._destroy) {
            formData.append(`${prefix}[_destroy]`, '1');
          } else {
            if (image.file) {
              formData.append(`${prefix}[image]`, image.file);
            }

            if (image.startDate) {
              formData.append(`${prefix}[start_date]`, this.formatDateTime(image.startDate, image.startTime));
            } else {
              formData.append(`${prefix}[start_date]`, '');
            }

            if (image.endDate) {
              formData.append(`${prefix}[end_date]`, this.formatDateTime(image.endDate, image.endTime));
            } else {
              formData.append(`${prefix}[end_date]`, '');
            }

            formData.append(`${prefix}[position]`, position);
            position++;
          }

          imageIndex++;
        });

        this.axios({
          method  : this.newFlag === true ? 'POST' : 'PUT',
          url     : this.newFlag === true ? this.AdminApiUrl + '/checkin_promotions/' : this.AdminApiUrl + '/checkin_promotions/' + this.$route.params.id,
          timeout : 30000,
          data: formData,
          headers : {
            'Authorization': this.$Cookies.get('accessToken'),
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
          if (!this.newFlag) {
            this.getPromotionImagePattern();
          }
          this.successAndBackPage(`販促画像パターン情報を`+this.buttonWord+`しました`,'/admin/checkin_promotion_list/')
        })
        .catch(error => {
          if (error?.response?.status === 401) {
            this.tokenError()
          } else if (error?.response?.data?.error?.includes("size_too_big")) {
            this.dangerNotify('販促画像のファイルサイズが大きすぎます。2MB以下の画像を選択してください。')
          } else if (error?.response?.data?.error?.includes("extension_whitelist_error")) {
            this.dangerNotify('販促画像の形式が不正です。jpg、jpeg、png形式の画像を選択してください。')
          } else {
            this.dangerNotify(`販促画像パターン情報を正しく`+this.buttonWord+`できませんでした`)
          }
        })
      },
      resetData () {
        this.brandId = '選択しない'
        this.promotionImagePatternName = ''
        this.status = 'not_active'
        this.images = [
          { id: null, imageInfo: '', file: null, startDate: '', startTime: '00:00', endDate: '', endTime: '00:00', _destroy: false }
        ]

        this.$validator.reset()
        setTimeout (times =>{
          for (var key in this.touched) {
            this.touched[key] = false
          }
        },100)
      }
    },
    mounted () {
      var url = location.href
      url = url.split('/')
      if(url[url.length - 1] === 'new') {
        this.newFlag = true
      } else {
        this.buttonWord = '更新'
        this.getPromotionImagePattern()
      }
      this.icons = this.TextIcons
    },
    watch: {
      '$route.path'(value){
        if (value.match('new')) {
          this.newFlag = true
          this.buttonWord = '登録'
          this.resetData()
        } else {
          this.newFlag = false
          this.buttonWord = '更新'
          this.getPromotionImagePattern()
        }
      },
      promotionImagePatternName(){
        this.touched.promotionImagePatternName = true
      },
      status () {
        this.touched.status = true
      }
    }
  }
</script>

<style lang="css" scoped>
.md-card .md-card-actions{
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.mt60{
  margin-top: 60px;
}

.error{
  color: #f44336 !important;
}

.success{
  color: #4caf50 !important
}

.image-form-item {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  position: relative;
}

.delete-form-button {
  position: absolute;
  top: 5px;
  right: 5px;
  margin: 0;
  width: 32px;
  height: 32px;
  min-width: 32px;
  z-index: 10;
}

.delete-form-button .md-icon {
  color: #f44336;
  font-size: 20px !important;
}

.delete-form-button:hover .md-icon {
  color: #d32f2f;
}

.order-controls {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  margin-bottom: 15px;
  width: 100%;
}

.order-number {
  font-weight: bold;
  font-size: 14px;
  color: #666;
  min-width: 20px;
  text-align: center;
}

.order-controls .md-button {
  margin: 0;
  width: 32px;
  height: 32px;
  min-width: 32px;
}

.order-controls .md-button .md-icon {
  font-size: 18px !important;
}

.order-controls .md-button[disabled] {
  opacity: 0.3;
}

.button-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.file-input {
  text-align: center;
}

.dateDelete {
  position: absolute;
  top: 0;
  right: 0;
}

@media screen and (max-width:600px) {
  .md-card .md-card-content .md-form-label{
    text-align: left;
  }

  .is-xs-none{
    display: none;
  }
}

</style>
